import {
    
    GET_REPORT_ALLTABLES_COUNT_PENDING,
    GET_REPORT_ALLTABLES_COUNT_FULFILLED,
    GET_REPORT_ALLTABLES_COUNT_REJECTED,

} from '../../actions/action-constants';

const initialState = {

    referrals: -1,
    archivedreferrals: -1,
    
    clients: -1,
    archivedclients: -1,
    
    postdischarges: -1,
    archivedpostdischarges: -1,
    
    programs: -1,
    
    logins: -1,
    
    loadingList: false,

    errors: [],
};

const reducerReferrals = (state = initialState, action) => {

  switch (action.type) {
    /* this was added with the redux promise middleware 
    you now have to put _FULFILLED, _REJECTED, after the action name to get the response
    without this middleware you will not get these status'
    */
    case GET_REPORT_ALLTABLES_COUNT_PENDING:
        state = {
            ...state
            , loadingList: true
        };
        break;
    case GET_REPORT_ALLTABLES_COUNT_FULFILLED:
                                                                                                // console.log('4444-30082 - reducerReports : GET_REPORT_ALLTABLES_COUNT_FULFILLED = ', action.payload);
                                                                                                // console.log('4444-30083 - reducerReports : GET_REPORT_ALLTABLES_COUNT_FULFILLED = ', action.payload.data);
                                                                                                // console.log('4444-30084 - reducerReports : GET_REPORT_ALLTABLES_COUNT_FULFILLED = ', action.payload.data.alltablescount);
                                                                                                // console.log('4444-30085 - reducerReports : GET_REPORT_ALLTABLES_COUNT_FULFILLED = ', action.payload.data.alltablescount[0]);
                                                                                                
                                                                                                    // 5 bopinstitutions 143 
                                                                                                    // 4 bhtsinsuranceproviders 3 
                                                                                                    // 0 alchoholaftercareprograms 3 

                                                                                                    // 6 clientdischargestatuses 4 
                                                                                                    // 7 clientdischargesubstatus 10 
                                                                                                    // 9 drugaftercareprograms 3 
                                                                                                    // 10 financialresponsibilityprograms 3 
                                                                                                    // 11 gangaffiliations 7 
                                                                                                    // 12 levelsofsecurity 4 
                                                                                                    // 13 loginroles 3 
                                                                                                    // 16 programs 8 
                                                                                                    // 17 referraloutcomes 6 
                                                                                                    // 19 referralsources 22 

        let referrals = -1;
        let archivedreferrals = -1;
        let clients = -1;
        let archivedclients = -1;
        let postdischarges = -1;
        let archivedpostdischarges = -1;
        let programs = -1;
        let logins = -1;

        if (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) {
            referrals = action.payload.data.alltablescount.find(o => o.TABLE_NAME === 'referrals').TABLE_ROWS;
            archivedreferrals = action.payload.data.alltablescount.find(o => o.TABLE_NAME === 'archivedreferrals').TABLE_ROWS;

            clients = action.payload.data.alltablescount.find(o => o.TABLE_NAME === 'clients').TABLE_ROWS;
            archivedclients = action.payload.data.alltablescount.find(o => o.TABLE_NAME === 'archivedclients').TABLE_ROWS;

            postdischarges = action.payload.data.alltablescount.find(o => o.TABLE_NAME === 'postdischarges').TABLE_ROWS;
            archivedpostdischarges = action.payload.data.alltablescount.find(o => o.TABLE_NAME === 'archivedpostdischarges').TABLE_ROWS;

            programs = action.payload.data.alltablescount.find(o => o.TABLE_NAME === 'programs').TABLE_ROWS;

            logins = action.payload.data.alltablescount.find(o => o.TABLE_NAME === 'logins').TABLE_ROWS;
        }

        state = {
            ...state,
            loadingList: false,

            referrals: referrals,
            archivedreferrals: archivedreferrals,
    
            clients: clients,
            archivedclients: archivedclients,
    
            postdischarges: postdischarges,
            archivedpostdischarges: archivedpostdischarges,
    
            programs: programs,
    
            logins: logins,
        };
        break;
    case GET_REPORT_ALLTABLES_COUNT_REJECTED:
                                                                                                console.log('4444-30021 - reducerReferrals : GET_REPORT_ALLTABLES_COUNT_REJECTED : error set = ');
        state = {
            ...state
                                                                                                // , errors: '${action.payload.data.message'
        };
        break;
    default:
        return state;
  }

  return state;
};

export default reducerReferrals;